import { Component, Input, OnInit } from '@angular/core';
import { EYesNo } from '../../../../shared/models/types.enum';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { TeacherStaffInterviewService } from '../../../../shared/services/teacherStaffInterview.service';

@Component({
  selector: 'review-teacher-staff-interview',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent
  ],
  templateUrl: './review-teacher-staff-interview.component.html',
  styleUrl: './review-teacher-staff-interview.component.css'
})
export class ReviewTeacherStaffInterviewComponent implements OnInit {

  @Input() caseId: string | null = null;
  
  yesNo = EYesNo;
  teacherStaffInterview: any | null = null;
  loading: boolean = false;
  
  sections = [
    {
      sectionName: "Staff Member Information",
      children: [
        {
          type: 'string',
          questionText: "Staff Member Interviewed:",
          answer: "staff_interviewed"
        },
        {
          type: 'date',
          questionText: "Date of Interview:",
          answer: "date_interview"
        },
        {
          type: 'string',
          questionText: "Time of Interview:",
          answer: "time_interview"
        },
        {
          type: 'string',
          questionText: "Person Conducting Interview:",
          answer: "person_conducting_interview"
        }
      ]
    },
    {
      sectionName: "Knowledge of Threat",
      children: [
        {
          type: 'string',
          questionText: "What do you know about the threatening situation prompting this review?",
          answer: "knowledge_of_threat"
        },
        {
          type: 'number',
          questionText: "Have you heard this student talk about violence, threats or dangerous behavior?",
          answer: "student_violence"
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: "student_violence_information"
        }
      ]
    },
    {
      sectionName: "Academics",
      children: [
        {
          type: 'string',
          questionText: "How is this student doing academically?",
          answer: "student_academics"
        },
        {
          type: 'string',
          questionText: "How well does the student express himself/herself verbally? In writing?",
          answer: "verbal_expression"
        },
        {
          type: 'number',
          questionText: "Have there been any recent changes in academic performance?",
          answer: "change_academic_performance"
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: "ichange_academic_performance_information"
        },
        {
          type: 'number',
          questionText: "Does this student receive intervention programming or specialized instruction?",
          answer: "intervention_programming"
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: "intervention_programming_information"
        }
      ]
    },
    {
      sectionName: "Behavior",
      children: [
        {
          type: 'string',
          questionText: "Have you experienced or observed behavior problems or changes in behavior with this student?",
          answer: "observed_behavior_problems"
        },
        {
          type: 'string',
          questionText: "How does this student respond to being corrected by an adult?",
          answer: "adult_correction"
        }
      ]
    },
    {
      sectionName: "Peer Relationships",
      children: [
        {
          type: 'string',
          questionText: "How well does this student get along with other students?",
          answer: "peer_relationship_student"
        },
        {
          type: 'string',
          questionText: "Who are the student's friends?",
          answer: "student_friends"
        },
        {
          type: 'string',
          questionText: "Are there students who do not get along with this student?",
          answer: "student_enemies"
        },
        {
          type: 'string',
          questionText: "Has this student ever talked about being bullied, teased, or treated unfairly by others?",
          answer: "bullying"
        },
        {
          type: 'number',
          questionText: "Have you observed or are you aware of conflicts or difficulties with peers?",
          answer: "peer_conflicts"
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: "peer_conflicts_information"
        }
      ]
    },
    {
      sectionName: "Depression",
      children: [
        {
          type: 'number',
          questionText: "Have you observed changes in the student's mood, demeanor, or activity level?",
          answer: "mood_changes"
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: "mood_changes_information"
        },
        {
          type: 'number',
          questionText: "Is the student withdrawn or apathetic?",
          answer: "withdrawn"
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: "withdrawn_information"
        },
        {
          type: 'number',
          questionText: "Has the student expressed any attitudes suggesting hopelessness, inadequacy, shame, self-criticism, or worthlessness?",
          answer: "hopelessness"
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: "hopelessness_information"
        },
        {
          type: 'number',
          questionText: "Is the student irritable or short-tempered?",
          answer: "irritable"
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: "irritable_information"
        },
      ]
    },
    {
      sectionName: "Aggression",
      children: [
        {
          type: 'number',
          questionText: "Has the student expressed anger or aggression?",
          answer: "student_aggression"
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: "student_aggression_information"
        },
        {
          type: 'number',
          questionText: "Does this student seem to hold a grudge or seem resentful?",
          answer: "grudge"
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: "grudge_information"
        }
      ]
    },
    {
      sectionName: "Parent Contact",
      children: [
        {
          type: 'number',
          questionText: "Have you had any contact with this student’s parents?",
          answer: "student_parent_contact"
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: "student_parent_contact_information"
        }
      ]
    },
    {
      sectionName: "Summary",
      children: [
        {
          type: 'number',
          questionText: "Is there another staff member or person who might know important details about this student or this situation?",
          answer: "important_details"
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: "important_details_information"
        },
        {
          type: 'number',
          questionText: "Is there other information regarding this student you have not yet shared that you believe would be important for the threat assessment team to consider?",
          answer: "information_threat"
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: "information_threat_information"
        }
      ]
    },
  ];

  constructor(
    private teacherStaffInterviewService: TeacherStaffInterviewService
  ) { }

  ngOnInit(): void {
    this.loadFullTeamThreatAssessment();
  }

  loadFullTeamThreatAssessment(): void {
    if (this.caseId) {
      this.loading = true;      
      this.teacherStaffInterviewService.getTeacherStaffInterviewByCaseId(this.caseId).subscribe({
        next: (response) => {
          this.teacherStaffInterview = response;
          this.loading = false;
        },
        error: (error) => {
          console.error('Error fetching teacher staff interview:', error);
          this.loading = false;
        }
      });
    }
  }

  showYesNo(answer: number): string {
    switch (answer) {
      case 0: return 'No';
      case 1: return 'Yes';
      case 2: return 'Need More Information';
      default: return 'N/A';
    }
  }

}
